import { EmployeeWithDelegates } from "@api/types/employeeswithdelegates";
import React, { useCallback, useContext, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { DelegatesList } from "./delegateslist";

interface Props {
  data: EmployeeWithDelegates;
  isOpen: boolean;
  onClickClose: () => void;
}

export const EmployeeWithDelegatesDetails: React.FC<Props> = ({
  data,
  isOpen,
  onClickClose,
}) => {
  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
  }

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog open={isOpen} onClose={onClickClose} fullWidth maxWidth="sm">
      <DialogTitle id="form-dialog-title" onClose={onClickClose}>
        Delegates of {data ? data.name : ""}
      </DialogTitle>
      <DialogContent>
        <DelegatesList
          employeeId={data.employeeId}
          userEmail={data.userEmail}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClickClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
